var ltr6_module_expandable_section = (function (ltr6_module_expandable_section) {
     // var privateToThisFile = "something";

    // add capabilities...

    // ltr6_module_expandable_section.publicProperty = "something";

    ltr6_module_expandable_section.init = function(){
      

      // EXPANDABLE SECTION
      // function checkHeight(){
      //   var minDistance = -50; // distance from the end of the text to end of cutoff point.
      //   if($('.ltr6-expandable-section').length){
      //     $.each($('.ltr6-expandable-section'), function(index, val) {
      //       var expandableRegion = $(this);
      //       var parent = expandableRegion.parent();
      //       var cc = 0;
      //       $.each(expandableRegion.children(), function(index, val) {
      //           cc += $(this).outerHeight(true,true);
      //       });
      //       var difference =  (parent.outerHeight() - cc);
      //       if(difference < minDistance){
      //       } else {
      //         // DISABLED EXPAND
      //         console.log('disable');
      //         expandableRegion.addClass('ltr6-expandable-section-disabled');
      //         var toggle = expandableRegion.parent().find('.ltr6-expandable-section-toggle');
      //         toggle.addClass('ltr6-expandable-section-disabled');
      //       }
      //       console.log('difference',difference);
      //     });
      //   }
      // }



      // checkHeight();

      


      // // =================================================================================================================
      // // 'Show more' expandable regions - using CSS transitions
      // // =================================================================================================================

      // function getParentEmptyHeight(expandableRegion){
      //   var parent = expandableRegion.parent();
      //   expandableRegion.hide();
      //   var parentHeight = parent.outerHeight();
      //   expandableRegion.show();
      //   return parentHeight;
      // }

      // function checkHeight(){
      //   var minDistance = 50; // distance from the end of the text to end of cutoff point.
      //   if($('.ltr6-expandable-section').length){
      //     console.log('exist');

      //     $.each($('.ltr6-expandable-section'), function(index, val) {
      //       var parent = $(this).parent();
      //       var expandableRegion = $(this);
      //       var expandedHeight = expandableRegion[0].scrollHeight;
      //       var currentHeight = expandableRegion.outerHeight();
      //       expandableRegion.hide();
      //       var parentHeight = parent.outerHeight();
      //       expandableRegion.show();
      //       var difference =  Math.abs(parentHeight - currentHeight);
      //       if(difference < minDistance){
      //         // DISABLED EXPAND
      //         console.log('diff',difference);
      //         expandableRegion.addClass('ltr6-expandable-section-disabled');
      //         var toggle = expandableRegion.parent().find('.ltr6-expandable-section-toggle');
      //         toggle.addClass('ltr6-expandable-section-disabled');
      //       } else {
      //         // expandableRegion.height(parentHeight);
      //         expandableRegion.css('height',parentHeight);
      //       }
      //       console.log('parentHeight',parentHeight);
      //       console.log('currentHeight',currentHeight);
      //       // if(difference<minDistance){
      //       //   console.log('pointless',difference);
      //       //   console.log('parent.outerHeight',parent.outerHeight());
      //       //   expandableRegion.show();
      //       //   // expandableRegion.addClass('ltr6-expandable-section-disabled');
      //       //   // var toggle = expandableRegion.parent().find('.ltr6-expandable-section-toggle');
      //       //   // toggle.addClass('ltr6-expandable-section-disabled');
      //       // }
      //       console.log('difference',difference);
      //       console.log('expandedHeight',expandedHeight);
      //       console.log('currentHeight',currentHeight);
      //     });
      //   }

      // }

      // checkHeight();


      // $('#ltr6-wrapper').on('click', '.ltr6-expandable-section-toggle', function(event) {
      //   //transition speed, needs to match CSS
      //   var cssTransitionSpeed = 500;

      //   event.preventDefault();
      //   event.stopPropagation();
      //   $(this).blur();
      //   var expandableRegion = $(this).prev('.ltr6-expandable-section');
      //   var toggle = $(this);
      //     var collapsedHeight = getParentEmptyHeight(expandableRegion);

      //   // console.log('ccc',getParentEmptyHeight(expandableRegion));
      //   // text labels and titles
      //   var collapsedText = toggle.attr('data-collapsed-text');
      //   var expandedText = toggle.attr('data-expanded-text');
      //   if(collapsedText=='') collapsedText = 'Show more';
      //   if(expandedText=='') expandedText = 'Show less';

      //   // get the expanded height
      //   var expandedHeight = expandableRegion[0].scrollHeight;

      //   if(!expandableRegion.hasClass('expanded')){
      //     // expand
      //     expandableRegion.addClass('expanded');
      //     expandableRegion.css('height',expandedHeight);
      //     // change text etc after transition
      //     setTimeout(function(){
      //       toggle.addClass('expanded');
      //       // set to auto afterwards so height isn't locked
      //       expandableRegion.css('height','auto');  
      //       toggle.html(expandedText);
      //       toggle.attr('title',expandedText);
      //     }, cssTransitionSpeed);
      //   } else {
      //     // collapse
      //     // get current height
      //     // var currentHeight = expandableRegion.outerHeight();
      //     // set height to actual current height in px
      //     expandableRegion.css('height',collapsedHeight);
      //     // wait a CPU cycle
      //     setTimeout(function(){
      //       // remove inline style so it transitions back to default
      //       expandableRegion.attr('style', function(i, style){
      //           return style && style.replace(/height[^;]+;?/g, '');
      //       });
      //       expandableRegion.removeClass('expanded');
      //     },0);
      //     // change labels at end of transition
      //     setTimeout(function(){
      //       toggle.removeClass('expanded');
      //       toggle.html(collapsedText);
      //       toggle.attr('title',collapsedText);
      //     }, cssTransitionSpeed);
      //   }

      // });





      // =================================================================================================================
      // 'Show more' expandable regions - using CSS transitions
      // collapsed height is set in css
      // transition speed is also set in CSS
      // IMPORTANT - transition speed in this needs to match the CSS transition speed
      // =================================================================================================================
      $('#ltr6-wrapper').on('click', '.ltr6-expandable-section-toggle', function(event) {
        //transition speed, needs to match CSS
        var cssTransitionSpeed = 500;

        event.preventDefault();
        event.stopPropagation();
        $(this).blur();
        var expandableRegion = $(this).prev('.ltr6-expandable-section');
        var toggle = $(this);

        // text labels and titles
        var collapsedText = toggle.attr('data-collapsed-text');
        var expandedText = toggle.attr('data-expanded-text');
        if(collapsedText=='') collapsedText = 'Show more';
        if(expandedText=='') expandedText = 'Show less';

        // get the expanded height
        var expandedHeight = expandableRegion[0].scrollHeight;


        if(!expandableRegion.hasClass('expanded')){
          // expand
          expandableRegion.removeClass('collapsed');
          expandableRegion.addClass('expanded');
          // expandableRegion.addClass('expanding');
          // expandableRegion.css('height',expandedHeight);
          // console.log('expanding to ',expandedHeight);
          TweenLite.to(expandableRegion,(cssTransitionSpeed/1000),{css:{'height':expandedHeight+'px'},ease:Power2.easeInOut,onComplete:function(){
           toggle.addClass('expanded');
           toggle.html(expandedText);
           toggle.attr('title',expandedText);
           expandableRegion.css('height','auto');
          }});

          // // set height to what it is now
          // var currentHeight = expandableRegion.outerHeight();
          // expandableRegion.css('height',currentHeight);
          // // wait a CPU cycle
          // setTimeout(function(){
          //   // set height to expanded height
          //   expandableRegion.css('height',expandedHeight);
          // },0);

          // // change text etc after transition
          // setTimeout(function(){
          //   toggle.addClass('expanded');
          //   // set to auto afterwards so height isn't locked
          //   // expandableRegion.css('height','auto');  
          //   toggle.html(expandedText);
          //   toggle.attr('title',expandedText);
          // }, cssTransitionSpeed);

          ltr6_module_analytics.tracking_adobe('Show More','Link','Click','First');
          ltr6_module_analytics.tracking_decibel('Show More','Link','Click','First');

        } else {
          // // collapse
          // // get current height
          // var currentHeight = expandableRegion.outerHeight();
          // // set height to actual current height in px
          // expandableRegion.css('height',currentHeight);
          // // wait a CPU cycle
          // setTimeout(function(){
          //   expandableRegion.css('height',0);
          //   // remove inline style so it transitions back to default
          //   expandableRegion.attr('style', function(i, style){
          //       // return style && style.replace(/min-height[^;]+;?/g, '');
          //   });
          //   expandableRegion.removeClass('expanded');
          // },0);
          // // change labels at end of transition
          // setTimeout(function(){
          //   toggle.removeClass('expanded');
          //   toggle.html(collapsedText);
          //   toggle.attr('title',collapsedText);
          // }, cssTransitionSpeed);
          expandableRegion.removeClass('expanded');
          expandableRegion.addClass('collapsed');

          var collapsedHeight = getHeightToCollapseTo();
          TweenLite.to(expandableRegion,(cssTransitionSpeed/1000),{css:{'height':collapsedHeight+'px'},ease:Power2.easeInOut,onComplete:function(){
            toggle.removeClass('expanded');
            toggle.html(collapsedText);
            toggle.attr('title',collapsedText);

          }});

        }

      });

      function getHeightToCollapseTo(){
        var contentHeight = $("#ltr6-wrapper .ltr6-trend-section-trend-overview .ltr6-trend-section-trend-overview-content").height();
        if(contentHeight<380) contentHeight = 380;
        // console.log('contentHeight',contentHeight);
        return contentHeight;
      }


      if($('#ltr6-wrapper .ltr6-trend').length){
        var resizeExpandableSectionOnWidthChange = ltr6_module_utilities.debounce(function() {
          var collapseToHeight = getHeightToCollapseTo() + 100;
          var contentHeight = $('#ltr6-wrapper .ltr6-trend-section-trend-overview .ltr6-expandable-section .ltr6-expandable-section-content').height();
          // $('#ltr6-wrapper .ltr6-trend-section-trend-overview .ltr6-expandable-section').height(contentHeight-30);
          // console.log('contentHeight',contentHeight);
          // console.log('collapseToHeight',collapseToHeight);
          if(contentHeight < collapseToHeight){
            console.log('1');
            $('#ltr6-wrapper .ltr6-trend-section-trend-overview .ltr6-expandable-section.collapsed').css('height','auto');
            
            $('#ltr6-wrapper .ltr6-trend-section-trend-overview .ltr6-expandable-section').addClass('expanded');
            $('#ltr6-wrapper .ltr6-trend-section-trend-overview .ltr6-expandable-section').removeClass('collapsed');
            $('#ltr6-wrapper .ltr6-trend-section-trend-overview .ltr6-expandable-section-toggle').hide();
            $('#ltr6-wrapper .ltr6-trend-section-trend-overview .ltr6-expandable-section-toggle').addClass('expanded');
            $('#ltr6-wrapper .ltr6-trend-section-trend-overview .ltr6-expandable-section-toggle').removeClass('collapsed');
            $('#ltr6-wrapper .ltr6-trend-section-trend-overview .ltr6-expandable-section-toggle').html('Show less');
          } else {
            console.log('2');
            $('#ltr6-wrapper .ltr6-trend-section-trend-overview .ltr6-expandable-section.collapsed').css('height',0);
            setTimeout(function(){
              $('#ltr6-wrapper .ltr6-trend-section-trend-overview .ltr6-expandable-section.collapsed').css('height',(collapseToHeight-100)+'px');
            }, 0);

            $('#ltr6-wrapper .ltr6-trend-section-trend-overview .ltr6-expandable-section').addClass('collapsed');
            $('#ltr6-wrapper .ltr6-trend-section-trend-overview .ltr6-expandable-section').removeClass('expanded');
            $('#ltr6-wrapper .ltr6-trend-section-trend-overview .ltr6-expandable-section-toggle').show();
            $('#ltr6-wrapper .ltr6-trend-section-trend-overview .ltr6-expandable-section-toggle').addClass('collapsed');
            $('#ltr6-wrapper .ltr6-trend-section-trend-overview .ltr6-expandable-section-toggle').removeClass('expanded');
            $('#ltr6-wrapper .ltr6-trend-section-trend-overview .ltr6-expandable-section-toggle').html('Show more');

          }
        }, 50);
        window.addEventListener('resize', resizeExpandableSectionOnWidthChange);
        resizeExpandableSectionOnWidthChange();
      }




    };

    return ltr6_module_expandable_section;
}(ltr6_module_expandable_section || {}));